var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:!_vm._isMobile ? 'mt88' : 'warpMt'},[(!_vm._isMobile)?_c('contactusPc',{attrs:{"inviteList":_vm.inviteList}}):_c('contactusMobile',{attrs:{"inviteList":_vm.inviteList}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-30f27186","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/contactus.vue
// module id = null
// module chunks = 